import { Tooltip } from 'antd';
import Copy from "assets/svgs/copy";
import _ from 'lodash';
import { useOrderSearchForTicket } from 'modules/CreateTicket/store';
import SoftBadge from "modules/common/SoftBadge";
import CardDiv from "modules/common/card-div/CardDiv";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";

function Ticket({ phoneNo, id, history, slotTime }) {
  const { fetchCrmCategories, crmCategories } = useOrderSearchForTicket();
  useEffect(() => {
		_.isEmpty(crmCategories) && fetchCrmCategories();
	}, []);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Tooltip title='Ticket Details'>
        <div onClick={handleShow}>
          <Copy />
        </div>
      </Tooltip>
      <Offcanvas
        show={show}
        style={{ width: "30%" }}
        onHide={handleClose}
        placement={"end"}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="w-100">
            <div className="w-100 d-flex justify-content-between align-items-center fs-2">
              <span className="d-flex align-items-center gap-2">
                Ticket <SoftBadge bg="info">{id}</SoftBadge>
                <SoftBadge
                  bg="secondary align-self-center"
                  className="text-black"
                >
                  {phoneNo}
                </SoftBadge>
              </span>
            </div>
            {slotTime && (
              <span className="d-flex align-items-center gap-2">
                Slot Time
                <SoftBadge
                  bg="secondary align-self-center"
                  className="text-black"
                >
                  {moment(slotTime).format("DD-MMM-YYYY hh:mm")}
                </SoftBadge>
              </span>
            )}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ maxHeight: "90vh", overflowY: "scroll" }}
            className="scrollable-container"
          >
            {history.map((ticket) => {
              return (
                <div className="m-3">
                  <CardDiv
                    title={<h4>{ticket.event}</h4>}
                    component={
                      <ul className="text-black">
                        <li>{ticket.description}</li>
                        {ticket.slot && <li>Slot Time : {moment(ticket.slot.slotTime).format("h:mm A, Do MMMM YYYY")}</li>}
                        {ticket.doctor_call_attempt && <li>Doctor Call Attempt: {ticket.doctor_call_attempt}</li>}
                        {ticket.doctor_assignment_count && <li>Doctor Assignment Count: {ticket.doctor_assignment_count}</li>}
                        <li>Author : {ticket.action_taker.first_name} (Time/Date :{" "}{moment(ticket.created_at).format("h:mm A, Do MMMM YYYY")})</li>
                      </ul>
                    }
                  />
                </div>
              );
            })}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Ticket;
